export default class PISet {
  static instructionKeys = [
    "passingDirectness",
    "pressingIntensity",
    "attackingWidth",
    "movement",
    "dribbling",
    "passingRisks",
    "crossingFrequency",
    "crossingPosition",
    "creativeFreedom",
    "shooting",
    "marking",
    "tackling",
    "lateralDribbling",
    "holdUpBall",
    "makeMoreSurgingForwardRuns",
    "makeMoreDartingRuns",
    "dropDeepMore",
    "getFurtherForward",
    "sitOffFromDeep",
    "carryTheBallMore",
    "useMoreTacticalDiscipline",
    "collectTheBallMore",
    "trackBackMore",
    "makeMoreDisciplinedMovement",
    "makeMoreDribblesIntoChannels",
    "makeMoreRoamingMovementLaterally",
    "focusPlay",
    "shootMoreOftenInPenaltyBox",
    "moveIntoCentralDefenceInPossession",
    "moveIntoCentralMidfieldInPossession",
  ];

  constructor(instructionData = {}) {
    for (const key of PISet.instructionKeys) {
      this[key] = instructionData[key] || 0;
    }
  }

  listInstructions() {
    const setInstructions = [];
    for (const key of PISet.instructionKeys) {
      if (this[key] !== 0) {
        setInstructions.push({
          name: key,
          value: this[key],
        });
      }
    }
    return setInstructions;
  }
}
